import { render, staticRenderFns } from "./Form4473Uploaded.vue?vue&type=template&id=63c412e9"
import script from "./Form4473Uploaded.vue?vue&type=script&lang=js"
export * from "./Form4473Uploaded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports